module.exports = __webpack_public_path__ + "static/media/JM.f85f0179.svg";